/**
 * Preferencia PREMIUM: auto-cargar serie sugerida en el viewport adyacente
 * al cambiar de serie en modo Comparar.
 */

export const COMPARE_AUTO_LOAD_KEY = 'udv.compare.autoLoadSuggested'

/**
 * @returns {boolean} default true
 */
export function loadCompareAutoLoadPref() {
  try {
    if (typeof localStorage === 'undefined') return true
    const v = localStorage.getItem(COMPARE_AUTO_LOAD_KEY)
    if (v == null || v === '') return true
    if (v === '0' || v === 'false' || v === 'off') return false
    return true
  } catch (e) {
    return true
  }
}

/**
 * @param {boolean} enabled
 */
export function saveCompareAutoLoadPref(enabled) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.setItem(COMPARE_AUTO_LOAD_KEY, enabled ? '1' : '0')
  } catch (e) {
    /* ignore */
  }
}
